/**
 * «¿Cuánto cuesta personalizar?» junto al botón — snippets/pp-precio-personalizacion.liquid.
 *
 * ~300 conversaciones de WhatsApp y chat en un mes (oct-2026) preguntaban
 * «¿cuánto cuesta la personalización?» o «¿hay algún cobro sólo la primera
 * vez?». Esta línea lo contesta en la ficha de una caja o bolsa personalizable:
 *
 *   «Tu logo en 1 cara suma $5.10 por caja en 25 cajas; desde $1.39 por caja
 *    en 3,200 cajas.»
 *   «IVA incluido. Se cobra por pieza en cada pedido, sin cargo de arranque.
 *    Ves el precio exacto en el estudio antes de pagar.»
 *
 * DE DÓNDE SALE CADA NÚMERO
 * De la ley del precio, nunca de aquí: GET a la RPC anon
 * `print_studio.escalera_personalizacion(p_shopify_product_id)` (monorepo,
 * migración 20261015000535). Cada renglón es lo que contestó
 * `precio_personalizacion()` en 1 paquete, en los bordes de cada tramo y en el
 * tope de la curva de volumen. Aquí sólo se ESCOGE: la entrada (el renglón de
 * menos paquetes) y el más barato (empate → la cantidad más chica que lo da).
 * El precio por pieza que se enseña es el MISMO que cobra el carrito:
 * (subtotal + IVA) / piezas a 2 decimales (`persoPorPiezaConIva` de la edge
 * ps-recotizar-linea): los precios de la tienda son con IVA.
 *
 * «SE COBRA POR PIEZA EN CADA PEDIDO, SIN CARGO DE ARRANQUE» — demostrado en
 * el código del monorepo: la ley no tiene término fijo (subtotal = precio por
 * pieza × piezas), el renglón de cobro de la caja (IUV-001) es por pieza, y
 * en la caja no existe ninguna exención de «ya pagado» (ésa vive sólo en la
 * cinta: `grabado_pagado_para_huella`). Sólo se dice cuando la escalera
 * contestó — o sea, cuando el producto se cobra con esa ley. Una cinta
 * (grabado de pago único) nunca llega aquí: la RPC no le contesta.
 *
 * SI LA LEY NO CONTESTA (red, timeout, cero renglones, basura) la línea dice
 * sólo «Ves el precio exacto en el estudio antes de pagar». Nunca un número
 * inventado ni un $0.
 *
 * Caché de 30 min por producto en sessionStorage (try/catch: privado o
 * bloqueado no truena). Un solo pedido por producto aunque el bloque se pinte
 * dos veces (escritorio y celular).
 *
 * La lógica pura va en window.PPPrecioPersonalizacion para que
 * tests/precio-personalizacion-ficha la corra con red falsa.
 */
(function () {
  'use strict';

  if (typeof window !== 'undefined' && window.PPPrecioPersonalizacion) return;

  var TTL_MS = 30 * 60 * 1000;
  var ESPERA_MS = 6000;
  var LLAVE = 'pp_precio_pers_v1_';

  // ── Lógica pura ──────────────────────────────────────────────────────────

  function num(v) {
    if (v === null || v === undefined || v === '') return NaN;
    var x = Number(v);
    return isFinite(x) ? x : NaN;
  }

  /** Lo que cobra el carrito por pieza: (subtotal + IVA) / piezas, 2 decimales. */
  function porPiezaConIva(fila) {
    if (!fila || typeof fila !== 'object') return null;
    var s = num(fila.subtotal), i = num(fila.iva), p = num(fila.piezas);
    if (!(p > 0) || !(s > 0) || !(i >= 0)) return null;
    var x = Number(((s + i) / p).toFixed(2));
    return x > 0 ? x : null;
  }

  /**
   * De los renglones de la escalera, la entrada (menos paquetes) y el más
   * barato (empate → menos piezas). `mejor` es null si no baja de la entrada.
   * null si no hay un solo renglón válido.
   */
  function elegir(filas) {
    if (!Array.isArray(filas)) return null;
    var validas = [];
    for (var k = 0; k < filas.length; k++) {
      var f = filas[k];
      var precio = porPiezaConIva(f);
      var piezas = num(f && f.piezas), paquetes = num(f && f.paquetes);
      if (precio === null || !(piezas > 0) || !(paquetes >= 1)) continue;
      if (Math.floor(piezas) !== piezas || Math.floor(paquetes) !== paquetes) continue;
      validas.push({ paquetes: paquetes, piezas: piezas, precio: precio, porPaquete: num(f.piezas_por_paquete) });
    }
    if (!validas.length) return null;
    var entrada = validas[0], mejor = validas[0];
    for (var j = 1; j < validas.length; j++) {
      var v = validas[j];
      if (v.paquetes < entrada.paquetes) entrada = v;
      if (v.precio < mejor.precio || (v.precio === mejor.precio && v.piezas < mejor.piezas)) mejor = v;
    }
    return { entrada: entrada, mejor: mejor.precio < entrada.precio ? mejor : null };
  }

  function miles(entero) {
    return String(entero).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /** 5.1 → «$5.10», 1234.5 → «$1,234.50». Siempre centavos: es precio por pieza. */
  function dinero(n) {
    var x = num(n);
    if (!(x >= 0)) return '';
    var partes = x.toFixed(2).split('.');
    return '$' + miles(partes[0]) + '.' + partes[1];
  }

  function llenar(plantilla, valores) {
    return String(plantilla || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(valores, k) ? valores[k] : m;
    });
  }

  /**
   * El sustantivo: el de la tienda («caja/cajas», de pp-unidades) sólo si su
   * paquete trae las MISMAS piezas que la ley; si no, «pieza/piezas» — la
   * cantidad de la ley es de piezas y no se le pone el nombre de otra cosa.
   */
  function unidad(eleccion, tienda, textos) {
    var t = tienda || {};
    var paqueteTienda = num(t.paquete);
    if (t.singular && t.plural && paqueteTienda > 0 && paqueteTienda === eleccion.entrada.porPaquete) {
      return { singular: t.singular, plural: t.plural };
    }
    return { singular: textos.pieza_singular || 'pieza', plural: textos.pieza_plural || 'piezas' };
  }

  /** { linea, nota } a partir de la elección; sin elección, sólo la nota del estudio. */
  function frase(eleccion, textos, tienda) {
    textos = textos || {};
    if (!eleccion) return { linea: '', nota: textos.estudio || '' };
    var u = unidad(eleccion, tienda, textos);
    var valores = {
      precio: dinero(eleccion.entrada.precio),
      n: miles(eleccion.entrada.piezas),
      singular: u.singular,
      plural: u.plural
    };
    var plantilla = textos.sin_desde;
    if (eleccion.mejor) {
      valores.precio_desde = dinero(eleccion.mejor.precio);
      valores.n_desde = miles(eleccion.mejor.piezas);
      plantilla = textos.con_desde;
    }
    var nota = [textos.como_se_cobra, textos.estudio].filter(Boolean).join(' ');
    return { linea: llenar(plantilla, valores), nota: nota };
  }

  function leerCache(almacen, id, ahora) {
    try {
      var crudo = almacen && almacen.getItem(LLAVE + id);
      if (!crudo) return null;
      var c = JSON.parse(crudo);
      if (!c || !Array.isArray(c.filas) || !(ahora - c.t < TTL_MS)) return null;
      return c.filas;
    } catch (e) { return null; }
  }

  function guardarCache(almacen, id, filas, ahora) {
    try { if (almacen) almacen.setItem(LLAVE + id, JSON.stringify({ t: ahora, filas: filas })); } catch (e) { /* lleno o bloqueado */ }
  }

  /**
   * Pide la escalera. Promesa de un arreglo de renglones o null (red, timeout,
   * respuesta no-200, cuerpo que no es arreglo). Nunca rechaza.
   */
  function pedir(cfg) {
    var id = String(cfg.producto || '');
    var base = String(cfg.url || '').replace(/\/+$/, '');
    if (!/^\d{1,20}$/.test(id) || !/^https:\/\//.test(base) || !cfg.key || typeof cfg.fetch !== 'function') {
      return Promise.resolve(null);
    }
    var ahora = cfg.ahora ? cfg.ahora() : Date.now();
    var guardado = leerCache(cfg.almacen, id, ahora);
    if (guardado) return Promise.resolve(guardado);

    var control = typeof AbortController === 'function' ? new AbortController() : null;
    var reloj = control && typeof setTimeout === 'function'
      ? setTimeout(function () { control.abort(); }, cfg.espera || ESPERA_MS) : null;

    return Promise.resolve()
      .then(function () {
        return cfg.fetch(base + '/rest/v1/rpc/escalera_personalizacion?p_shopify_product_id=' + id, {
          method: 'GET',
          headers: { apikey: cfg.key, 'Accept-Profile': 'print_studio', Accept: 'application/json' },
          signal: control ? control.signal : undefined
        });
      })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (filas) {
        if (!Array.isArray(filas)) return null;
        guardarCache(cfg.almacen, id, filas, ahora);
        return filas;
      })
      .catch(function () { return null; })
      .then(function (filas) { if (reloj) clearTimeout(reloj); return filas; });
  }

  // ── DOM ──────────────────────────────────────────────────────────────────

  function textosDe(el) {
    var nodo = el.querySelector('[data-pp-precio-pers-textos]');
    try { return JSON.parse(nodo ? nodo.textContent : '{}') || {}; } catch (e) { return {}; }
  }

  function pintar(el, filas) {
    var textos = textosDe(el);
    var tienda = {
      paquete: el.getAttribute('data-pp-precio-pers-paquete'),
      singular: el.getAttribute('data-pp-precio-pers-singular'),
      plural: el.getAttribute('data-pp-precio-pers-plural')
    };
    var eleccion = elegir(filas);
    var f = frase(eleccion, textos, tienda);
    var linea = el.querySelector('[data-pp-precio-pers-linea]');
    var nota = el.querySelector('[data-pp-precio-pers-nota]');
    if (eleccion && linea) {
      linea.textContent = f.linea;
      linea.hidden = false;
    }
    if (nota && f.nota) nota.textContent = f.nota;
    el.setAttribute('data-pp-precio-pers-estado', eleccion ? 'listo' : 'sin-precio');
  }

  function iniciar(doc, deps) {
    deps = deps || {};
    var bloques = doc.querySelectorAll('[data-pp-precio-pers]');
    var porProducto = {};
    for (var i = 0; i < bloques.length; i++) {
      var el = bloques[i];
      var id = el.getAttribute('data-pp-precio-pers-producto') || '';
      (porProducto[id] = porProducto[id] || []).push(el);
    }
    var promesas = Object.keys(porProducto).map(function (id) {
      var primero = porProducto[id][0];
      return pedir({
        producto: id,
        url: primero.getAttribute('data-pp-precio-pers-url'),
        key: primero.getAttribute('data-pp-precio-pers-key'),
        fetch: deps.fetch,
        almacen: deps.almacen,
        ahora: deps.ahora,
        espera: deps.espera
      }).then(function (filas) {
        porProducto[id].forEach(function (el) { pintar(el, filas); });
      });
    });
    return Promise.all(promesas);
  }

  var api = {
    porPiezaConIva: porPiezaConIva,
    elegir: elegir,
    dinero: dinero,
    frase: frase,
    pedir: pedir,
    pintar: pintar,
    iniciar: iniciar
  };

  if (typeof window !== 'undefined') window.PPPrecioPersonalizacion = api;

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && window.fetch) {
    var arrancar = function () {
      var almacen = null;
      try { almacen = window.sessionStorage; } catch (e) { almacen = null; }
      iniciar(document, { fetch: window.fetch.bind(window), almacen: almacen });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
  }
})();
